<header class="header">
  <div class="header__container">
    <a [href]="logoUrl" class="header__logo">
      <img [alt]="brand + ' logo'" [src]="logo" class="header__logo" />
    </a>
    <span class="header__navigation">
      <a *ngFor="let item of navigationItems" [routerLink]="item.route" class="header__navigation-item">
        {{ item.label }}
      </a>
    </span>
    <span class="header__spacer"></span>
    <div class="header__actions">
      <ng-content select="[slot=actions]"></ng-content>
    </div>
  </div>
</header>
